<template>
  <div class="elinkht">
    <!-- 图片 -->
    <div class="head-img">
      <div class="header-title">
        <div class="h-content">
          <div class="h-title">大宗一站通平台</div>
          <div class="h-subtitle">大宗供应链「采销运融」 智慧平台，通过科技赋能产业，解决大宗供应链行业联通</div>
        </div>
      </div>
    </div>
    <!-- 标签页 -->
    <el-tabs
      ref="tabBox"
      v-model="activeName"
      class="elinkht-tabs"
      @tab-change="handleClick"
    >
      <el-tab-pane class="elinkht-tabs-item" name="transactions">
        <template #label>
          <div class="elinkht-tabs-item-label">线上交易</div>
        </template>
        <div class="elinkht-tabs-box box">
          <div class="title">大宗一站通线上平台</div>
          <div class="text">
            应用数智化技术，为大宗供应链上下游企业提供涵盖线上交易、智慧物流数字仓储、供应链金融等关键节点的信息科技服务，助力大宗供应链产业数智化升级。
          </div>
          <img
            class="box-img"
            :src="require('@/assets/img/solution/elinkht/transactions.png')"
          />
          <el-row justify="center" :gutter="12">
            <el-col :xs="8" :sm="8">
              <div class="elinkkt-tag">采销需求量大质优，一站式交易拓渠道</div>
            </el-col>
            <el-col :xs="8" :sm="8">
              <div class="elinkkt-tag">智慧物流降本增效，运输调度一步到位</div>
            </el-col>
            <el-col :xs="8" :sm="8">
              <div class="elinkkt-tag">在线操作可视可溯，业务管理高效合规</div>
            </el-col>
            <el-col :xs="8" :sm="8">
              <div class="elinkkt-tag">线上融资方便快捷，金融工具触手可及</div>
            </el-col>
            <el-col :xs="8" :sm="8">
              <div class="elinkkt-tag">产业数据丰富沉淀，一手资讯辅助决策</div>
            </el-col>
          </el-row>
          <el-row class="centent-cards" justify="center" gutter="12">
            <el-col :xs="8" :sm="8">
              <div class="box-card">
                <div class="card-header">
                  <div class="card-title">身份认证</div>
                </div>
                <ul class="card-centent">
                  <li>小额打款</li>
                  <li>法人四要素</li>
                  <li>网银证书</li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="8" :sm="8">
              <div class="box-card">
                <div class="card-header">
                  <div class="card-title">线上签约</div>
                </div>
                <ul class="card-centent">
                  <li>电子协议</li>
                  <li>CFCA认证</li>
                  <li>交易完整</li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="8" :sm="8">
              <div class="box-card">
                <div class="card-header">
                  <div class="card-title">线上结算</div>
                </div>
                <ul class="card-centent">
                  <li>电子专票</li>
                  <li>全电发票</li>
                  <li>发票验真</li>
                </ul>
              </div>
            </el-col>
          </el-row>
          <div class="text text-mg">
            平台为用户提供直接交易、招投标、竞价购买等多种在线交易服务，
            实现征信查询、司法查询、身份认证、电子签约、支付结算、发票开具等全流程线上化。
          </div>
          <ldiv class="text"
            >交易全流程可视、可溯、不可篡改，真正实现业财合一，大大降低买卖双方交易成本。</ldiv
          >
        </div>
      </el-tab-pane>
      <el-tab-pane class="elinkht-tabs-item" name="intelligence-logistics">
        <template #label>
          <div class="elinkht-tabs-item-label">智慧物流</div>
        </template>
        <div class="elinkht-tabs-box box">
          <div class="title">智慧物流</div>
          <div class="text">
            物流模块基于团队对全国重点矿山、港口、终端地区的关键信息（产量、价格、物流路线及成本等）近20年的数据积累，为用户提供包含汽运、水运、铁运及多式联运等多种运输服务的综合物流方案。
          </div>
          <img
            class="box-img"
            :src="
              require('@/assets/img/solution/elinkht/intelligence-logistics.png')
            "
          />
          <el-row :gutter="10">
            <el-col :xs="12" :sm="6"
              ><div class="il-item">
                <img
                  :src="
                    require('@/assets/img/solution/elinkht/intelligence-logistics1.svg')
                  "
                />
                水路运输
              </div></el-col
            >
            <el-col :xs="12" :sm="6"
              ><div class="il-item">
                <img
                  :src="
                    require('@/assets/img/solution/elinkht/intelligence-logistics2.svg')
                  "
                />公路运输
              </div></el-col
            >
            <el-col :xs="12" :sm="6"
              ><div class="il-item">
                <img
                  :src="
                    require('@/assets/img/solution/elinkht/intelligence-logistics3.svg')
                  "
                />铁路运输
              </div></el-col
            >
            <el-col :xs="12" :sm="6"
              ><div class="il-item">
                <img
                  :src="
                    require('@/assets/img/solution/elinkht/intelligence-logistics4.svg')
                  "
                />多式联运
              </div></el-col
            >
          </el-row>
          <div class="text">
            借助物联网、智能监控、机器自动学习（建模）等技术手段，平台能针对特定场景进行智能分析，
            确保匹配的物流线路最优、成本最低，全程可追踪可管控。
          </div>
        </div></el-tab-pane
      >
      <el-tab-pane
        class="elinkht-tabs-item"
        label="数字化仓储"
        name="digital-warehousing"
      >
        <template #label>
          <div class="elinkht-tabs-item-label">数字化仓储</div>
        </template>
        <div class="elinkht-tabs-box box">
          <div class="title">数字化仓储</div>
          <div class="text">
            平台仓储能力覆盖全国核心城市，通过智能仓储技术实现货物从入库、在库到出库的全流程在线管控。
          </div>
          <div class="text text-mg">
            应用
            Al视频识别、电子围栏等智能设备，提高仓库现场操作的时效性和准确性。
          </div>
          <div class="text">
            通过
            3D可视化调度平台，仿真还原动态货物信息，实现仓储管理数字化和业务一体化。
          </div>
          <img
            class="box-img"
            :src="
              require('@/assets/img/solution/elinkht/digital-warehousing.png')
            "
          />
          <el-row class="dw-card" gutter="24">
            <el-col :xs="24" :sm="12">
              <div class="box-card">
                <div class="card-header">
                  <div class="card-title">仓储商</div>
                </div>
                <ul class="card-centent">
                  <li>获取更多仓储商机</li>
                  <li>在线签约、付款和开票</li>
                  <li>轻松管理库存信息，提高运营效率</li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12">
              <div class="box-card">
                <div class="card-header">
                  <div class="card-title">货主</div>
                </div>
                <ul class="card-centent">
                  <li>高效匹配仓储需求，省时省力</li>
                  <li>快速对接仓储和入仓货物，无缝衔接</li>
                  <li>在线监管实时库存信息，货物动态随时掌握</li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane
        class="elinkht-tabs-item"
        label="供应链金融"
        name="supply-chain-finance"
      >
        <template #label> <div>供应链金融</div> </template>
        <div class="elinkht-tabs-box box">
          <div class="title">供应链金融</div>
          <div class="text text-mg1">
            供应链金融模块为用户，尤其是中小供应链企业，提供交易订单融资、仓单质押融资、
            应收账款融资、普惠融资等多种融资方式。通过团结核心金融企业，帮助中小企业顺利实现资产融资。
          </div>
          <el-row :gutter="10">
            <el-col :xs="12" :sm="6"
              ><div class="il-item">应收账款融资</div></el-col
            >
            <el-col :xs="12" :sm="6"
              ><div class="il-item">仓单融资</div></el-col
            >
            <el-col :xs="12" :sm="6"
              ><div class="il-item">订单融资</div></el-col
            >
            <el-col :xs="12" :sm="6"
              ><div class="il-item">普惠融资</div></el-col
            >
          </el-row>
          <div class="scf-text">
            <div class="scf-title">融资方便快捷</div>
            <div class="text">
              应用了人工智能和物联网技术，为煤矿打造全场最的数智化服务应用。
            </div>
            <div class="text text-mg">
              通过搭建矿借助 ABCDI
              (Al、BlockChain、CloudComputing、BigData、loT)
              等核心技术平台实现与线下业务场景物联网的联通对接，基于用户在平台生成的身份、交易、仓储等真实订单信息所形成的数字化资产，结合司法、税务、历史订单等大数据风控，生成用户数字资产价值画像。
            </div>
            <div class="text text-mg1">
              平台用户从而得以更方便快捷地获得银行、保理等金融机构合作方提供的资金支持。
            </div>
          </div>
          <div class="scf-text">
            <div class="scf-title">放贷精准安全</div>
            <div class="text">
              基于团队对煤炭、钢材等大宗行业的深入了解及资源沉淀，平台得以实现风控前置，帮助金融机构提升获客精度与客户质量，降低资产不良率与获客成本。
            </div>
            <div class="text text-mg">
              通过自研风险决策引擎工具，平台还能对融资项目进行全流程的监控，精准识别可能存在的欺诈等风险并发出预警。
            </div>
            <div class="text text-mg1">
              未来，平台将基于区块链、大数据、人工智能等新一代信息技术，持续加强贷前、贷中、贷后的风险处置能力，强化信贷风险管理。
            </div>
            <img
              :src="require('@/assets/img/solution/elinkht/supply-chain-finance.png')"
              style="
                width: 100%;
                height: auto;
                background: #f7f8fa;
                border-radius: 4px 4px 4px 4px;
              "
            />
          </div></div
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "transactions",
    };
  },
  watch: {
    // 监听路由的变化
    $route(to, from) {
      this.getParam();
    },
  },
  mounted() {
    this.getParam();
  },

  methods: {
    getParam() {
      const nameList = [
        "transactions",
        "intelligence-logistics",
        "digital-warehousing",
        "supply-chain-finance",
      ];
      let name = this.$route.params.activeName;
      console.log("this.$route.params=====>", this.$route.params);
      if (nameList.includes(name)) {
        this.activeName = name;
      }
    },
    handleClick(name) {
      // // 获取目标元素的DOM节点
      // const targetElement = this.$refs.tabBox.$el;
      // // 计算目标位置的像素值，假设1rem = 16px
      // const targetPosition = 5.4 * 16; // 66rem * 16px/rem = 1056px

      // // 使用scrollTo方法实现平滑滚动
      // window.scrollTo({
      //   top: targetElement.offsetTop - targetPosition,
      //   behavior: "smooth",
      // });
      this.$router.replace({
        path: `/solution/elinkht/${name}`,
        target: "_self",
      });
      this.activeName = name;
    },
  },
};
</script>

<style lang="less" scoped>

::v-deep .el-tabs__active-bar{
  bottom: 1px;
  background-color:#075ffc;
}
::v-deep .el-tabs__nav-wrap::after{
  height: 1px;
}
::v-deep .el-tabs__item:hover{
  color: #1E2328;
}
.elinkht {
  // line-height: 0px;
}
.head-img {
  width: 100%;
  height: 40rem;
  background: #f1f3f5;
  background-image: url(@/assets/img/solution/elinkht/elinkht.png);
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .header-title {
    width: 120rem;
    margin: auto;
    display: flex;
    align-items: center;
    height: 100%;
    .h-content {
      .h-title {
        font-size: 32px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 1.6rem;
      }
      .h-subtitle {
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
      }
    }
  }
}
/* 居中标签页的标签 */
::v-deep .el-tabs__nav-scroll {
  .el-tabs__nav {
    float: none;
    justify-content: center;
  }
}

::v-deep .el-tabs__item {
  font-size: 14px;
  padding: 0 6rem;
  font-weight: 400;
  color: #878f9b;
  line-height: 20px;
}

::v-deep .el-tabs__item.is-active {
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #1e2328;
  line-height: 20px;
}

// 外层主体
.box {
  width: 90rem;
  margin: 8rem auto;
  .title {
    text-align: center;
    font-size: 32px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1e2328;
    line-height: 32px;
    margin-bottom: 4rem;
  }
  .text {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #4f5969;
    line-height: 20px;
  }
  .text-mg {
    margin: 2rem 0;
  }
  .text-mg1 {
    margin-bottom: 2rem;
  }
  .box-img {
    width: 100%;
    margin: 2.4rem auto;
    border-radius: 4px 4px 4px 4px;
  }
}

.elinkht-tabs-box {
  .elinkkt-tag {
    text-align: center;
    background: #f7f8fa;
    border-radius: 4px 4px 4px 4px;
    padding: 1rem 2.7rem;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #1e2328;
    line-height: 20px;
    margin-bottom: 12px;
  }

  .dw-card {
    margin-top: 2.4rem;
    .el-col {
      .box-card {
        background: #f7f8fa;
        border-radius: 4px 4px 4px 4px;
        .card-header {
          padding: 2.4rem 2.4rem 0;
          .card-title {
            text-align: center;
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 28px;
            background: #075ffc;
            border-radius: 4px 4px 4px 4px;
            padding: 1.6rem 8.8rem;
          }
        }
        .card-centent {
          padding-left: 2.4rem;
          padding-bottom: 2.4rem;
          margin: 2.4rem 2.4rem 0 2.4rem;
          list-style: disc;
          li {
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2328;
            line-height: 32px;
          }
        }
      }
      .box-card-end {
        // padding: 0 !important;
      }
    }
  }

  .centent-cards {
    margin-top: 1.2rem;
    .el-col {
      .box-card {
        background: #f7f8fa;
        border-radius: 4px 4px 4px 4px;
        .card-header {
          padding: 2.4rem 1.8rem 0 1.8rem;
          .card-title {
            text-align: center;
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 28px;
            background: #075ffc;
            border-radius: 4px 4px 4px 4px;
            padding: 1.6rem 8.8rem;
          }
        }
        .card-centent {
          padding-left: 2.4rem;
          padding-bottom: 2.4rem;
          margin: 2.4rem 2.4rem 0 2.4rem;
          list-style: disc;
          li {
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2328;
            line-height: 32px;
          }
        }
      }
      .box-card-end {
        // padding: 0 !important;
      }
    }
  }
  .il-item {
    display: flex;
    background: #f1f3f5;
    border-radius: 4px 4px 4px 4px;
    // text-align: center;
    justify-content: center;
    padding: 0.7rem 0;
    font-size: 20px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #1e2328;
    line-height: 28px;
    margin-bottom: 24px;
    img {
      margin-right: 0.8rem;
    }
  }

  .scf-text {
    .scf-title {
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #1e2328;
      line-height: 28px;
      margin-bottom: 1.2rem;
    }
  }
}

.elinkht-tabs {
  // margin: 1rem 0;
  --el-tabs-header-height: 48px;
  ::v-deep .el-tabs__header {
    margin: 0;
  }
}

@media (max-width: 1200px) {
  .elinkht-tabs {
    .elinkht-tabs-box {
      .supply-chain-finance-img {
        .el-col {
          .box-card {
            height: auto;
          }
        }
      }
    }
  }
}

@media (max-width: 900px) {
}
@media (max-width: 900px) {
 .head-img {
    width: 100%;
    height: 20rem;
    // background: #f1f3f5;
    .header-title {
      color: #ffffff;
      width: 100%;
      justify-content: center;
      padding: 0 1.6rem;
      .h-content {
        text-align: center;
        .h-title {
          font-size: 24px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 32px;
          margin-bottom: 0.6rem;
        }
        .h-subtitle {
          font-size: 10px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
        }
      }
    }
  }

  ::v-deep .el-tabs__item {
    font-size: 10px;
    padding: 0 2rem;
  }
  ::v-deep .el-tabs__item.is-active {
    font-size: 10px;
  }

  // 外层主体
  .box {
    width: 100%;
    margin: 6rem auto;
    padding: 0 1.6rem;
    .title {
      text-align: center;
      font-size: 24px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1e2328;
      line-height: 32px;
      margin-bottom: 4rem;
    }
    .text {
      font-size: 10px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4f5969;
      line-height: 20px;
    }
    .text-mg {
      margin: 1.2rem 0;
    }
    .text-mg1 {
      margin-bottom: 1.2rem;
    }
    .box-img {
      width: 100%;
      margin: 2.4rem auto;
    }
  }

  .elinkht-tabs-box {
    .elinkkt-tag {
      text-align: center;
      background: #f7f8fa;
      border-radius: 4px 4px 4px 4px;
      padding: 0.8rem 1.2rem;
      font-size: 10px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #1e2328;
      line-height: 20px;
      margin-bottom: 8px;
    }

    .dw-card {
      margin-top: 2.4rem;
      .el-col {
        margin-bottom: 1.2rem;
        .box-card {
          background: #f7f8fa;
          border-radius: 4px 4px 4px 4px;
          .card-header {
            padding: 1.2rem 1.2rem 0;
            .card-title {
              text-align: center;
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 28px;
              background: #075ffc;
              border-radius: 4px 4px 4px 4px;
              padding: 0.8rem 4.4rem;
            }
          }
          .card-centent {
            padding-left: 1.2rem;
            padding-bottom: 1.2rem;
            margin: 2.4rem 2.4rem 0 2.4rem;
            list-style: disc;
            li {
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #1e2328;
              line-height: 32px;
            }
          }
        }
        .box-card-end {
          // padding: 0 !important;
        }
      }
    }

    .centent-cards {
      margin-top: 1.2rem;
      .el-col {
        margin-bottom: 1.2rem;
        .box-card {
          background: #f7f8fa;
          border-radius: 4px 4px 4px 4px;
          .card-header {
            padding: 1.2rem 0.9rem 0 0.9rem;
            .card-title {
              text-align: center;
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 28px;
              background: #075ffc;
              border-radius: 4px 4px 4px 4px;
              padding: 0rem 1.6rem;
            }
          }
          .card-centent {
            padding-left: 1.2rem;
            padding-bottom: 1.2rem;
            margin: 1.2rem 1.2rem 0;
            list-style: disc;
            li {
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #1e2328;
              line-height: 18px;

            }
          }
        }
      }
    }
    .il-item {
      display: flex;
      background: #f1f3f5;
      border-radius: 4px 4px 4px 4px;
      // text-align: center;
      justify-content: center;
      padding: 0.7rem 0;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #1e2328;
      line-height: 28px;
      margin-bottom: 12px;
      img {
        margin-right: 0.2rem;
      }
    }

    .scf-text {
      .scf-title {
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #1e2328;
        line-height: 28px;
        margin-bottom: 1.2rem;
      }
    }
  }
}
</style>